<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1569 10L20.0396 13.5493L27.8798 10.5235L36 13.6574V15.0778H35.4824L27.8798 12.1437L19.997 15.1859L12.1569 11.6558L4.59082 15.0625H4V13.6727L12.1569 10Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1569 17.907L20.0396 21.4563L27.8798 18.4305L36 21.5644V22.9849H35.4824L27.8798 20.0507L19.997 23.093L12.1569 19.5629L4.59082 22.9696H4V21.5797L12.1569 17.907Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1569 25.8141L20.0396 29.3634L27.8798 26.3376L36 29.4715V30.8919H35.4824L27.8798 27.9577L19.997 31L12.1569 27.4699L4.59082 30.8766H4V29.4868L12.1569 25.8141Z"
      class="fill-current"
    />
  </svg>
</template>
